import { Component, OnInit } from '@angular/core';
import { HealthService } from '../services/health.service';

@Component({
  selector: 'app-health',
  templateUrl: './health.component.html',
  styleUrls: ['./health.component.css'],
})
export class HealthComponent implements OnInit {
  message: string;

  constructor(private healthService: HealthService) {}

  ngOnInit(): void {
    this.healthService.getHealth().subscribe(
      (response) => {
        this.message = response.status;
        console.log(response.status);
      },
      (error) => {
        this.message = error.errorMessage;
        console.error(error.errorMessage);
      }
    );
  }
}
